import { frCommons } from './frCommons';
import { frMapElementDictionnary } from './frMapElementDictionnary';

//🇫🇷

const frProjects = {
    Projects_Title: 'Mes projets',
    Projects_ListItemTitle: 'Créer un projet',
    Projects_CreatedBy: 'Créé par {user}',
    Projects_CreatedBy_Store: 'le magasin {storeId}',
    Projects_CreatedBy_Client: 'Client',
    Projects_CreatedByDate: 'le {date}',
    Projects_LastSave: 'Dernière sauvegarde :',
    Projects_Search_Placeholder: 'Rechercher un projet',

    Projects_Import: 'Importer un projet',
    Projects_Import_Success: '{imported_count} projet(s) importé(s) avec succès.',
    Projects_Import_Ignored: '{ignored_count} projet(s) ignoré(s)',
    Projects_Import_ExistedProjectIgnored: 'Le projet existe déjà.\n(ID CLIENT : {customerId})',
    Projects_Import_Error: "Erreur lors de l'import du projet",
    Projects_Import_CustomerOverrideDialogTitle: 'Import du projet',
    Projects_Import_CustomerOverrideDialogBody:
        'Vous êtes connecté en tant que client.\n\nSouhaitez vous importer ce(s) projet(s) pour le client actuel ? (customer_id override)',

    Projects_SeeMore: 'Voir le détail',
    ProjectDetails_Resume: 'Continuer le projet',
    ProjectDetails_DeleteProject: 'Supprimer le projet',
    ProjectDetails_AreaValue: '{area} m²',
    ProjectDetails_AmountValue: '{amount} €',
    ProjectDetails_RoomCountValue: 'pièce(s)',
    ProjectDetails_WithoutPrestation: 'Sans prestation',
    ProjectDetails_ProjectSummary: 'Résumé du projet',
    ProjectDetails_Area: 'Superficie :',
    ProjectDetails_OpeningCount: "Nombre d'ouvertures :",
    ProjectDetails_RoomCount: 'Nombre de pièces :',
    ProjectDetails_LastSave: 'Dernière sauvegarde :',
    ProjectDetails_CreatedBy: 'Créé par :',
    ProjectDetails_CustomerId: 'ID Client :',
    ProjectDetails_Intitule: 'Intitulé du projet',
    ProjectDetails_Description: 'Description',
    ProjectDetails_HistoryList: 'Historique des versions du projet',
    ProjectDetails_Version_CreationDate: 'Date de création',
    ProjectDetails_Version_RoomCount: 'Nombre de pièces',
    ProjectDetails_Version_RoomCount_Short: 'Nbr pièces',
    ProjectDetails_version_Amount: 'Montant',
    ProjectDetails_DialogEditIntituleInformation: "Veuillez saisir l'intitulé du projet",
    ProjectDetails_DialogEditDescriptionInformation: 'Veuillez saisir la description du projet',
    ProjectDetails_DialogEditCustomerIdInformation: "Veuillez saisir l'ID Client du projet",
    ProjectDetails_Export: 'Exporter le projet',

    ProjectDetails_Description_Placeholder: 'Saisissez votre description ici',
    ProjectDetails_DeleteDialogTitle: 'Supprimer le projet',
    ProjectDetails_DeleteDialogHeader: 'Vous êtes sur le point de supprimer un projet',

    //!\\ USED IN ESTIMATION PAGE
    CreateProjectDialog_InputLabel: 'Donnez un nom à ce projet.',
    CreateProjectDialog_InputPlaceholder: 'Ex : Chambre',

    CreateOrUpdateProjectDialog_Message: 'Sur quel projet voulez-vous enregistrer ? ',
    CreateOrUpdateProjectDialog_SaveProject: 'Enregistrer sur le projet « {name} »',
    CreateOrUpdateProjectDialog_NewProject: 'Créer un nouveau projet et enregistrer',
    CreateOrUpdateProjectDialog_InputLabel: 'Nom du projet',

    Quote_Project_Created: 'Le projet « {name} » a été crée avec succès',
    Quote_Project_ConfigurationUpdated: 'La configuration du projet « {name} » a été mis à jour',

    DeadEndSaveButton: 'Enregistrer mon projet',
};

const frLaizeCalcDialog = {
    //* Analyse calcul en lés
    LaizeCalcDialog_Title: 'Studio',
    LaizeCalcDialog_Stairs_Title: 'Studio Escalier',
    LaizeCalcDialog_Back: 'Retour',
    LaizeCalcDialog_Params_Title: 'Paramètres',
    LaizeCalcDialog_Params_Type: 'Type :',
    LaizeCalcDialog_Params_Type_rouleau: 'Rouleau',
    LaizeCalcDialog_Params_Type_lamePleine: 'Lame pleine',
    LaizeCalcDialog_Params_LaizeMargin: 'Marge interne lé {readonly}',
    LaizeCalcDialog_Params_BandWidth: 'Largeur rouleau {readonly}',
    LaizeCalcDialog_Params_RaccordLength: 'Taille raccord {readonly}',
    LaizeCalcDialog_Params_MotifWidth: 'Largeur motif {readonly}',
    LaizeCalcDialog_Params_MotifLength: 'Longueur motif {readonly}',
    LaizeCalcDialog_Params_LongueurCm: 'Longueur {readonly}',
    LaizeCalcDialog_Params_LaizeConsecutiveBandsMargin: 'Marges supplémentaires {readonly}',
    LaizeCalcDialog_Params_ReadonlyValueFormat: '{value} cm',

    LaizeCalcDialog_ProductSelector_Title: 'Produit :',
    LaizeCalcDialog_IterationStep_Title: 'Placer les bandes :',

    LaizeCalcDialog_Band_Title: 'BANDE {index}',
    LaizeCalcDialog_Band_Lenght: 'Longueur :',
    LaizeCalcDialog_Band_Width: 'Largeur :',

    LaizeCalcDialog_LaizeResult_Total: 'TOTAL : ',
    LaizeCalcDialog_LaizeResult_RaccordLength: 'Longueur raccord  :',
    LaizeCalcDialog_LaizeResult_FormatM: '{value} m',
    LaizeCalcDialog_LaizeResult_FormatML: '{value} mL',

    LaizeCalcDialog_LaizeDirection_Part1: 'SENS',
    LaizeCalcDialog_LaizeDirection_Part2: 'DE POSE',

    LaizeCalcDialog_StairType_MarcheDroite: 'Marche Droite',
    LaizeCalcDialog_StairType_MarcheTournante: 'Marche Tournante',
    LaizeCalcDialog_StairType_MarcheArrondie: 'Marche Arrondie',
    LaizeCalcDialog_StairType_Palier: 'Palier',

    LaizeCalcDialog_StairType_Short_MarcheDroite: 'MD',
    LaizeCalcDialog_StairType_Short_MarcheTournante: 'AU',
    LaizeCalcDialog_StairType_Short_MarcheArrondie: 'MA',
    LaizeCalcDialog_StairType_Short_Palier: 'PL',
};

const frFinDeParcours = {
    FinDeParcours_Title: 'Finalisez votre projet',
    FinDeParcours_Step_Options: 'Options',
    FinDeParcours_Step_Syntheses: 'Synthèse',
    FinDeParcours_Step_Quote: 'Devis',

    FinDeParcours_Step_Options_Title: 'Mes Options',

    FinDeParcours_Step_Syntheses_Title: 'Synthèse de Mon projet',
    FinDeParcours_Step_Syntheses_StoreTitle: 'Le magasin qui prendra en charge votre projet : ',
    FinDeParcours_Step_Syntheses_StoreChange: 'Changer de magasin',
    FinDeParcours_Step_Syntheses_StoreMessage:
        'Un conseiller va vous contacter pour vous accompagner sur votre projet.',

    FinDeParcours_Step_ChangesAlert:
        'Ces informations ont un impact direct sur le calcul de votre estimation.\nChanger vos réponses nécessitera peut-être de répondre à nouveau à certaines questions.\nSouhaitez-vous continuer ?',

    FinDeParcours_Step_Syntheses_Room_Title_Format_Sol: '{name} - SOL',
    FinDeParcours_Step_Syntheses_Room_Title_Format_Wall: '{name} - MUR',
    FinDeParcours_Step_Syntheses_Room_Title_Format_Stairs: '{name} - ESCALIER',

    FinDeParcours_Step_Quote_Title: 'Mon Devis',
    FinDeParcours_Step_Quote_TotalTitle: 'Confiez la pose de vos produits à nos experts',
    FinDeParcours_Step_Quote_Subtitle:
        'Prises de mesures, diagnostic, préparation des sols... nos experts assurent la pose de votre chantier !',

    FinDeParcours_Step_Quote_DeletePrestationMessage:
        'Vous êtes en train de supprimer la main-d’œuvre du devis. Êtes-vous sûr de vouloir continuer ?',
    FinDeParcours_Step_Quote_AddPrestationMessage:
        "Vous êtes en train d'ajouter la main-d’œuvre du devis. Êtes-vous sûr de vouloir continuer ?",

    FinDeParcours_Step_Congratulation_Title: 'félicitations',
    FinDeParcours_Step_Congratulation_Subtitle: 'vous avez terminé votre projet !',
    FinDeParcours_Step_Congratulation_Text:
        'Félicitations vous avez finalisé votre projet. Un conseiller du magasin de {ville} va recevoir votre\nprojet et vous rappeler dans les prochaines heures. Si vous le souhaitez, vous pouvez également\nprendre rendez-vous pour suivre votre projet (validation des produits, diagnostic technique, prises\nde mesure).',
};

const frStoreLocator = {
    StoreLocator_HeaderTitle: 'Recherche Votre MAGASIN',
    StoreLocator_SelectStore: 'Choisir ce magasin',
    StoreLocator_NearMyProject: 'Proche de mon projet',
    StoreLocator_SearchPlaceholder: 'Ex: Paris 75000',
    StoreLocator_SearchTitle: 'Saisissez votre code postal ou le nom de votre ville.',
    StoreLocator_SearchResults: '{count} magasins à proximité',

    StoreLocator_Store_Days: 'Horaires',
    StoreLocator_Store_Day_1: 'Lundi :',
    StoreLocator_Store_Day_2: 'Mardi :',
    StoreLocator_Store_Day_3: 'Mercredi :',
    StoreLocator_Store_Day_4: 'Jeudi :',
    StoreLocator_Store_Day_5: 'Vendredi :',
    StoreLocator_Store_Day_6: 'Samedi :',
    StoreLocator_Store_Day_7: 'Dimanche :',
    StoreLocator_Store_Open: 'Ouvert',
    StoreLocator_Store_Closed: 'Fermé',
};

const frStairs = {
    StairsCell_ProduitMarchesTitle: 'Produit des marches',
    StairsCell_ProduitContremarchesTitle: 'Produit des contremarches',
    StairsCell_ProduitEmptyTitle: 'Affinez votre pièce',
    StairsCell_ProduitEmptyDescription: 'Complétez les informations{br}manquantes sur votre escalier.',
    StairsCell_Marches: 'Marches ({quantity})',
    StairsCell_Contremarches: 'Contremarches ({quantity})',

    StairsTypePanel_AddTitle: 'Ajoutez un escalier',
    StairsTypePanel_UpdateTitle: 'Modifier un escalier',
    StairsTypePanel_Subtitle: 'Quel type d’escalier souhaitez-vous recouvrir ?',

    StairsTypePanel_WithRiser: 'Avec{break}contremarche',
    StairsTypePanel_WithoutRiser: 'Sans{break}contremarche',

    StairsTypePanel_Dialog_Title: 'Êtes-vous sûr ?',
    StairsTypePanel_Dialog_Message:
        'Si vous changez le type de cet escalier, vous devrez saisir à nouveau la liste de vos marches.',

    EditStairs_AddStepsTitle: 'Ajouter des marches',
    EditStairs_AddStepsSubtitle: 'Complétez votre escalier en ajoutant les marches dans l’ordre.',

    EditStairs_DeleteStepsTitle: 'Supprimer les marches ?',
    EditStairs_DeleteStepsMessage:
        'Cette action supprimera définitivement le groupe de marches sélectionné de votre escalier. Elle est irréversible.',

    EditStairs_SectionTitle: 'Liste des marches',

    EditStairs_AddStepsTop: 'Ajouter des marches en haut',
    EditStairs_AddStepsBottom: 'Ajouter des marches en bas',
    EditStairs_AddStairs: "Ajouter l'escalier",

    EditStairs_Row_Marches: 'Emmarchement : {value} cm',
    EditStairs_Row_Giron: 'Giron : {value} cm',
    EditStairs_Row_Contremarches: 'Contremarche : {value} cm',
    EditStairs_Row_Quantity: 'Qté : {value}',

    EditStairs_StepsType_MarcheDroite: 'Droite',
    EditStairs_StepsType_MarcheTournante: 'Tournante',
    EditStairs_StepsType_MarcheArrondie: 'Arrondie',
    EditStairs_StepsType_Palier: 'Palier',

    EditStairs_StepsTitle: 'Configuration de la marche',
    EditStairs_StepsType: 'Type *',
    EditStairs_StepsQuantity: 'Nombre de marches*',
    EditStairs_StepsMarches: 'Emmarchement *',
    EditStairs_StepsGiron: 'Giron *',
    EditStairs_StepsContremarches: 'Contremarche*',
    EditStairs_StepsHelp:
        "L'emmarchement correspond à la largeur de la marche, c'est la distance d'un côté à l'autre de l'escalier quand on regarde de face. Le Giron correspond à la profondeur de la marche, partie sur laquelle on pose le pied. Si l'escalier possède des contremarches, il est nécessaire d'indiquer la hauteur entre les marches. Pour chaque partie, on indique toujours les plus grandes dimensions",

    StairsLaize_WidthOverflow_Error: 'Une ou plusieurs marches dépassent la largeur de la bande.',
};

const frOnboarding = {
    Floorplan_HowItWorksOnboarding_Title: 'Comment ça marche ?',
    Floorplan_HowItWorksOnboarding_0: 'Décrivez votre habitation',
    Floorplan_HowItWorksOnboarding_1: 'Dessinez votre plan',
    Floorplan_HowItWorksOnboarding_2: 'Détaillez votre projet',
    Floorplan_HowItWorksOnboarding_3: 'Visualisez votre devis',
    Floorplan_HowItWorksOnboarding_Start: 'Je réalise mon devis estimatif',
    Floorplan_Onboarding_Skip: 'Passer',
    Floorplan_Onboarding_Final: 'Démarrer mon plan',
    Floorplan_Onboarding_Footer_Label: 'Ne plus afficher',
};

const frMapMenu = {
    MapSwitch_Sol: 'Sol',
    MapSwitch_Wall: 'Mur',
    MapSwitch_Stairs: 'Escalier',

    Room_Title_Sol: 'Pièce',
    Room_Title_Wall: 'Murs',

    Opening_Title: 'Ouvertures /{br}Aménagements',

    MapContextMenu_Modify: 'Modifier',
    MapContextMenu_Complete: 'Compléter',
    MapContextMenu_Add: 'Ajouter',
    MapContextMenu_Move: 'Déplacer',
    MapContextMenu_Duplicate: 'Dupliquer',
    MapContextMenu_Rotate_AntiHoraire: 'Pivoter de -90°',
    MapContextMenu_Rotate_Horaire: 'Pivoter de 90°',
    MapContextMenu_DivideWall: 'Diviser le mur',
    MapContextMenu_Delete: 'Supprimer',
    MapContextMenu_Delete_Sol: 'Supprimer la pièce {name}',
    MapContextMenu_Delete_Wall: 'Supprimer le mur {name}',
    MapContextMenu_Delete_Stairs: `Supprimer l'escalier "{name}"`,

    MapContextMenu_Delete_Title: 'Êtes-vous sûr ?',
};

const frQuestions = {
    Quote_Advice: 'Notre conseil',
    Quote_MultipleOptionsLabel_SubText: '(plusieurs choix possibles)',

    Quote_QuestionNumberError: 'la valeur doit être comprise entre {min} et {max}',
    Quote_ProductSelect_Search: 'Chercher un autre produit',
    Quote_ProductSelect_Search_NoResult: 'Le produit « {search} » n’existe pas dans notre catalogue.',
    Quote_ProductSelect_Search_Empty: 'Aucun produit selectionné',
    Quote_ProductSelect_Suggest_SameAsBefore: 'Le même que choisi précédemment',

    Quote_IncompatibilityAnswer:
        "Oups, ce choix n'est pas possible avec ce que vous avez sélectionné auparavant. Ok pour changer cette réponse",
    Quote_IncompatibilityAnswer_RedirectButton: 'Choisir un autre produit dans le catalogue',

    QuoteStepViewModel_ReadonlyProduct_Error: 'Le produit souhaité n’existe pas dans le catalogue.',
    QuoteStepViewModel_TravelExpense_Unallowed_Error:
        "Il n'est pas possible d'expédier une commande à cette adresse. Nous livrons exclusivement en France Métropolitaine.",
    QuoteStepViewModel_TravelExpense_Error: "Le code postal saisi n'a pas été trouvé.",

    CardWithDetails_Reference: 'Réf: ',
    CardWithDetails_ReferenceFormat: 'Réf: {value}',
    CardWithDetails_ConditionnementPar: 'Paquet(s) de {value} {unit} ',
    CardWithDetails_Inclus: 'INCLUS',

    ZipCodeQuestion_DialogTitle: 'Votre code postal',
    ZipCodeQuestion_DescriptionLabel: 'Localité : ',

    Question_Help: 'En savoir plus',

    Product_Ref: 'RÉF : {ref}',
    Product_TTC_Label: '*TTC', //!\\ not used anymore
    Product_Promo_Banner: 'Promo',
    Product_TVA_Label: 'TVA {percent}',
};

const frEstimation = {
    Estimation_RollOver_Title_Complete: 'Finalisez votre projet',
    Estimation_RollOver_Title_ToDo: 'Finaliser mon projet',
    Estimation_RollOver_Title_NoRoom_Sol: 'Ajouter une pièce',
    Estimation_RollOver_Title_NoRoom_Wall: 'Ajouter un mur',
    Estimation_RollOver_Title_NoRoom_Stairs: 'Ajouter un escalier',

    Estimation_Header_Title: 'DEVIS ESTIMATIF',
    Estimation_Pdf_Title: 'Télécharger le devis estimatif',

    Estimation_Store_Title: 'Le magasin le plus proche',
    Estimation_Store_Change: 'Changer de magasin',

    Estimation_Price_Total_HT: 'Total H.T.',
    Estimation_Price: 'DÉTAIL PRIX',
    Estimation_Price_Total_TVA_PERCENTAGE: 'Total TVA ({percentage}%)',
    Estimation_Price_Total_TTC: 'Total TTC',
    Estimation_Price_Total_EcoContribution: 'Dont éco-contribution',

    Estimation_Synthese_General: 'Infos générales',
    Estimation_NotCompleted: 'COMPLÉTEZ VOS PIÈCES POUR OBTENIR VOTRE DEVIS ESTIMATIF',
    Estimation_NotCompleted_Button: 'Complétez votre projet',
    Estimation_NotCompleted_NoRoom: 'CRÉEZ LE PLAN DE VOTRE HABITATION POUR OBTENIR UN DEVIS ESTIMATIF',
    Estimation_NotCompleted_NoRoom_Button: 'Reprendre mon parcours',
    Estimation_ShowEstimation: 'Voir mon devis',
    Estimation_Recap_Produit_Principal: 'Produit principal à poser',
    Estimation_Recap_Produits_Principaux: 'Produits principaux à poser',
    Estimation_Recap_Produit_Complementaire: 'Produits complémentaires',
    Estimation_Recap_Produit_Quantity: 'Quantité : ',
    Estimation_Recap_Produit_QuantityFormat: '{quantity} {unit}',
    Estimation_Recap_Produit_Paquet: '{count} paquet(s) de {conditionnement} {unit}',
    Estimation_Recap_Produit_Unitaire: 'Unitaire',
    Estimation_Recap_Produit_TotalPrice: 'Soit ',
    Quote_Product_UnitPrice: 'Prix unitaire :',
    Quote_Product_TotalTtc: 'Total TTC :',

    Estimation_Recap_Main_Oeuvre: 'Main d’œuvre',
    Estimation_Recap_Pose_Depose: 'Dépose',
    Estimation_Recap_Pose_Preparation_Support_Avant_Pose: 'Préparation du support avant pose',
    Estimation_Recap_Pose_Revetement_Principal: 'Pose du revêtement principal',
    Estimation_Recap_Pose_Accessoires: 'Pose accessoires',
    Estimation_Recap_Pose_Complement_Forfait_Divers: 'Complément forfait divers',
    Estimation_Recap_Pose_Nettoyage: 'Nettoyage',
    Estimation_Recap_Pose_Autres: 'Autres',
    Estimation_Recap_Pose_Forfait_Besoin_Supplementaire: 'Forfait besoin supplémentaire',
    Estimation_Recap_Pose_Gestion_Dechets: 'Gestion des déchets',
    Estimation_Recap_Livraison: 'Livraison',
};

const frAlertMessages = {
    //* TOAST
    Toast_TitleSuccess: 'Bravo',
    Toast_TitleError: 'Erreur',
    Toast_TitleInfo: 'Info',

    ERROR_LOADING_CONFIGURATION: "La configuration n'a pas pu être chargé.",
    ERROR_AUTHENTICATION_IFRAME_TIMEOUT: "Impossible de joindre le serveur d'authentification, merci de réessayer.",
    Error_FORBIDDEN: "Quelque chose ne s'est pas passé comme prévu, merci de réessayer.",
    ERROR_UPDATE_UNAUTHORIZED: "Vous n'avez pas les droits nécessaire pour éditer ce projet.",
    ERROR_LOADING_MAP: "Quelque chose ne s'est pas passé comme prévu lors du chargment du plan.",

    ERROR_STORE_TOKEN_IN_FUTUR: 'Problème de synchro NTP',
    ERROR_CUSTOMER_TOKEN_IN_FUTUR: "Veuillez vérifier l'heure de votre appareil.",
    ERROR_INVALID_WALL_MOVE: 'Ce déplacement rentre en collision avec une autre pièce',
    ERROR_ALL_WALLS_LOCKED: 'Déverrouiller les murs pour redimensionner',
    ERROR_POINT_LOCKED: '🔒 Point restreint par des murs verrouillés',
    ERROR_WALL_LOCKED: '🔒 Mur restreint par des murs verrouillés',
    ERROR_INVALID_ROOMITEM_SIDE_MOVE: 'Ce déplacement rentre en collision avec un mur ou un autre aménagement',
    ERROR_INVALID_ROOMITEM_OUTSIDE_ROOM: 'Suppression amenant un aménagement en dehors de la pièce',

    ERROR_ROOM_HEATING_TYPE_MISSING_TITLE: 'Type de chauffage manquant',
    ERROR_ROOM_HEATING_TYPE_MISSING_CONTENT:
        'Il semblerait que le type de chauffage soit manquant, merci de renseigner cette information dans votre projet avant de poursuivre',

    ERROR_INVALID_OPENING: 'Ce déplacement va mettre en superposition des ouvertures',
    ERROR_DELETE_INVALID_OPENING: "L'ouverture {ouvertureName} placée de manière invalide, a été supprimée.",

    CopyToClipboardButton_CopiedSnakbarMessage: 'Copié dans le presse-papier',

    PermissionDialog_NotAuthenticated: "Vous n'êtes pas authentifié",

    //* DIALOG
    GlobalErrorFallbackDialog_Title: 'Erreur globale',
    GlobalErrorFallbackDialog_Subtitle_ProjectInProgress: `Une erreur est survenue. Sauvegarder le projet ?`,
    GlobalErrorFallbackDialog_Subtitle_NoProjectInProgress: `Une erreur est survenue. Recharger la page.`,

    Dialog_LogoutTitle: 'Déconnexion',
    Dialog_LogoutMessageHeader: 'Vous êtes sur le point de vous déconnecter',
    Dialog_Error_CantCompleteProject:
        'Nous sommes désolés mais nous ne pouvons pas finaliser votre devis estimatif en ligne.\nEnregistrez votre projet dans votre compte client, un conseiller vous contactera pour le finaliser.',
    DialogLogin_Error_CantCompleteProject:
        'Nous sommes désolés mais nous ne pouvons pas finaliser votre devis estimatif en ligne.\nUn conseiller va prendre contact avec vous afin de finaliser votre projet.',

    MapErrorFallbackDialog_Title: 'Erreur sur le plan',
    MapErrorFallbackDialog_Subtitle: `Nous allons annuler votre denière action.`,

    AmenagementDialog_Title: "Êtes-vous sûr de ne pas avoir d'aménagement ?",
    AmenagementDialog_Subtitle_Sol: `Une ouverture peut être une porte, porte-fenêtre, baie vitrée ou même un passage ouvert vers une autre pièce.\nUn aménagement peut être un placard, une douche, des meubles de cuisine ... soit des éléments que nous déduisons de la surface totale de la pièce.\nPositionnez-les pour avoir l'estimation la plus juste possible !`,
    AmenagementDialog_Subtitle_Wall: `Une ouverture peut être une porte, une fenêtre...\nUn aménagement peut être un tuyau, un obstacle ... soit des éléments importants dans le calcul de votre devis.\nPositionnez-les pour avoir l'estimation la plus juste possible !`,
    AmenagementDialog_Subtitle_Stairs: `Une marche est un élément important dans le calcul de votre devis.\nPositionnez-les pour avoir l'estimation la plus juste possible !`,
    AmenagementDialog_Yes: 'Finalisez votre projet',

    OpeningWarning_RoomInfoIncomplete_Dialog_Title: 'Il manque quelque chose',
    OpeningWarning_RoomInfoIncomplete_Dialog_Subtitle: `Merci de compléter la section "Ma pièce" pour ajouter un aménagement sur cette pièce.`,
    OpeningWarning_RoomInfoIncomplete_Dialog_CTA: 'Compléter "Ma pièce"',

    OpeningWarning_SelectRoom_Dialog_Title: "Déplacement de l'ouverture",
    OpeningWarning_SelectRoom_Dialog_Subtitle: "Attacher l'ouverture à une pièce ?",
    OpeningWarning_SelectRoom_Dialog_Validate: 'Choisir cette pièce',

    MoveAmenagementWarning_Dialog_Title: 'Déplacement impossible',
    MoveAmenagementWarning_Dialog_Title_CTA: 'Annuler le déplacement',
    MoveOpeningWarning_Dialog_Subtitle: `Le type d'ouverture "{type}" n'est pas compatible sur les pièces {localisation}.`,
    MoveRoomItemWarning_Dialog_Subtitle: `Le type d'aménagement "{roomItemType}" n'est pas compatible sur les pièces {unit} - {localisation} - {roomType}.`,

    RoomItemDialog_Stairs_Warning: 'Attention : Cet élément représente une seule marche.',
    // RoomItemDialog_DimensionsWidthPropertyMissingError: "Veuillez saisir la largeur de l'élément.",
    // RoomItemDialog_DimensionsWidthPropertyMissingErrorLimits: 'Veuillez saisir la largeur comprise entre ({min}) et ({max}) cm',

    // RoomItemDialog_DimensionsLengthPropertyMissingError: "Veuillez saisir la longueur de l'élément.",
    // RoomItemDialog_DimensionsLengthPropertyMissingErrorLimits: 'Veuillez saisir la longueur comprise entre ({min}) et ({max}) cm',

    Quote_Alert_DesktopIsBetterAlertTitle: 'Nous vous invitons à continuer en utilisant un ordinateur',
    Quote_Alert_DesktopIsBetterAlertSubTitle:
        'Afin de profiter de manière optimale de notre outil, nous vous recommandons d’utiliser un ordinateur. N’ayez pas d’inquiétude, il vous suffit d’enregistrer votre projet. Vous pourrez le retrouver et reprendre exactement où vous en étiez !',
    Quote_Alert_DesktopIsBetterAlertSubStayOnMobile: 'Je poursuis sur mobile',
    Quote_Alert_DesktopIsBetterAlertSubStaySave: 'J’enregistre mon projet',

    Quote_Alert_ConfigNotSavedTitle: "Votre configuration de pose n'est pas enregistrée.",
    Quote_Alert_ConfigNotSavedSubTitle: 'En continuant, vous allez perdre vos modifications non enregistrées.',
    Quote_Alert_ConfigNotSavedCancelButton: 'Revenir sur le plan',

    //* when click on book an appointment
    Dialog_ProjectSaveHeader:
        "Votre projet n'est pas encore enregistré. Souhaitez-vous enregister votre projet ?\nPour obtenir un devis, vous devez enregistrer votre projet.",
    Dialog_ProjectSaveRequest: 'Souhaitez-vous enregister votre projet ?',

    Dialog_ProjectSaveDirtyHeader: 'Des modifications ont été apportées à votre projet',
    Dialog_ProjectSaveDirtyBody: "Confirmez-vous l'enregistrement des modifications ?",

    AddressDialog_Title: 'L’adresse du lieu de pose',
    AddressDialog_Description:
        "Afin d'éditer votre devis estimatif, nous avons\nbesoin de connaître l'adresse du lieu de pose.",
    AddressDialog_Placeholder: "L'adresse du lieu de pose",
    AddressDialog_Error_Mistmatch_ZipCode:
        "Les codes postaux ne sont pas identiques.\nVous pouvez retourner à l'étape habitation pour changer votre code postal.",

    LaizeCalcDialog_Toast_Error_InvalidWallStartDirections:
        'Un sens de pose de lame de terrasse est invalide. La disposition des lames va passer sur "optimisation des lames"',
};

export const frMessages = {
    Locale: 'fr-FR',
    ApplicationName: 'Clic & Pose',

    ...frCommons,
    ...frOnboarding,
    ...frMapElementDictionnary,
    ...frMapMenu,
    ...frQuestions,
    ...frEstimation,
    ...frProjects,
    ...frLaizeCalcDialog,
    ...frFinDeParcours,
    ...frStoreLocator,
    ...frStairs,
    ...frAlertMessages,

    TEST_STORE_USER_FULLNAME: 'Test vendeur: {firstName} {lastName}',
    TEST_CUSTOMER_USER_FULLNAME: 'Test client: {firstName} {lastName}',

    //! COMPONENTS

    //* Header

    Header_MySpace: 'Mon compte',
    Header_Logout: 'Se déconnecter',
    Header_Login: 'Se connecter',
    Header_MyProjects: 'Mes projets',

    Header_Version: '{environment} - {version_number}',
    Header_Environment_dev: 'development',
    Header_Environment_test: 'test',
    Header_Environment_beta: 'beta',
    Header_Environment_uat: 'uat',
    Header_Environment_preprod: 'pp',
    Header_Environment_prod: 'production',

    MonthYearPicker_Short_Label_January: 'Jan',
    MonthYearPicker_Short_Label_February: 'Fév',
    MonthYearPicker_Short_Label_March: 'Mars',
    MonthYearPicker_Short_Label_April: 'Avr',
    MonthYearPicker_Short_Label_May: 'Mai',
    MonthYearPicker_Short_Label_June: 'Juin',
    MonthYearPicker_Short_Label_July: 'Juil',
    MonthYearPicker_Short_Label_August: 'Août',
    MonthYearPicker_Short_Label_September: 'Sept',
    MonthYearPicker_Short_Label_October: 'Oct',
    MonthYearPicker_Short_Label_November: 'Nov',
    MonthYearPicker_Short_Label_December: 'Déc',

    LaizeLines_Title: 'CONSO PRODUIT',
    LaizeDirectionDialog_Description:
        "Le sens de pose ne se choisit pas au hasard, il impacte la quantité de produit : on peut opter pour une pose en fonction de l'entrée de la lumière dans la pièce, du sens de la marche ou encore en fonction du nombre de raccords. Si vous avez un projet multi-pièces le sens de pose sera identique. Réfléchissez-y, nous validerons avec vous !",
    LaizeView_Title: 'CONSO PRODUIT',
    LaizeDirectionView_length: 'Mètres linéaires',
    LaizeDirectionView_length_LamePleine_Horizontal: "Lames entières à l'horizontal",
    LaizeDirectionView_length_LamePleine_Vertical: 'Lames entières à la verticale',
    LaizeDirectionView_length_LamePleine_Classique: 'Optimisation des lames',

    PriceUnitFormat_M: 'le {unitPrice}',
    PriceUnitFormat_F: 'la {unitPrice}',
    PriceUnitFormat_m: 'm',
    PriceUnitFormat_m2: 'm²',
    PriceUnitFormat_Piece: 'pièce',

    //#endregion

    //! PLAN
    LegendInfoText_Sol: 'Les côtes représentent les dimensions intérieures des pièces.',
    LegendInfoText_Wall: 'Les côtes représentent les dimensions intérieures des murs.',

    FloorPlanTutorial_Add_Sol: 'Ajoutez{br}une pièce',
    FloorPlanTutorial_Add_Wall: 'Ajoutez{br}un mur',
    FloorPlanTutorial_Add_Stairs: 'Ajoutez{br}un escalier',

    FloorPlanTutorial_Edit_Sol: 'Modifiez les dimensions{br}de votre pièce',
    FloorPlanTutorial_Edit_Wall: 'Modifiez les dimensions{br}de votre mur',
    FloorPlanTutorial_Edit_Stairs: 'Modifiez les dimensions{br}de votre escalier',

    FloorPlanTutorial_Edit_Infos_Sol: '& Configurez votre pièce',
    FloorPlanTutorial_Edit_Infos_Wall: '& Configurez votre mur',
    FloorPlanTutorial_Edit_Infos_Stairs: '& Configurez votre escalier',

    FloorPlanTutorial_Edit_Infos_Mobile: '& Configurez la',
    Room_Area: '{area} m²',
    Room_AreaWithoutItems: '{area} m² / {areaWithoutRoomItems} m² utilisables',
    EditCoteDialog_Title: 'Édition de cote',
    EditCoteDialog_DimensionPropertyLabel: 'Dimension (cm)',
    EditCoteDialog_DimensionPropertyDescription: 'la cote doit être comprise entre ({min}) et ({max}) cm',

    //!PANELS
    RoomShapePannel_Title_Sol: 'Séléctionner la forme de votre pièce',
    RoomShapePannel_Title_Wall: 'Séléctionner la forme de votre mur',

    //!\\ RoomShape_Other : not used anymore
    RoomShape_Other: 'Autre',
    RoomShape_Other_Header: 'Pièce atypique',
    RoomShape_Other_Title: 'Votre pièce a une forme atypique ?',
    RoomShape_Other_Subtitle:
        "Faites plutôt deviser votre projet par l'un de nos experts afin d'obtenir l'estimation la plus précise possible.",
    RoomShape_Other_SaveAdvice: 'Un conseiller vous contactera dans les plus brefs délais',
    RoomShape_Other_AppointmentBtn: 'Prendre RDV',

    RoomEdit_Wall: 'Type de mur',
    RoomEdit_HeaderTitle_Sol: 'Ma pièce',
    RoomEdit_HeaderTitle_Wall: 'Mon mur',
    RoomEdit_HeaderTitle_Stairs: 'Mon escalier',
    RoomEdit_Title_Sol: 'Affinez votre pièce',
    RoomEdit_Title_Wall: 'Affinez votre mur',
    RoomEdit_Title_Stairs: 'Affinez votre escalier',
    RoomEdit_Subtitle_Sol: 'Complétez les informations manquantes sur votre pièce.',
    RoomEdit_Subtitle_Wall: 'Complétez les informations manquantes sur votre mur.',
    RoomEdit_Subtitle_Stairs: 'Complétez les informations manquantes sur votre escalier.',

    RoomEdit_Localisation_Dialog: `Les aménagements présents sur votre pièce ne sont pas compatibles avec votre changement. En continuant, vous allez les perdre.\nSouhaitez-vous continuer ?`,
    RoomEdit_Shape: 'Forme de la pièce',
    RoomEdit_Localisation: 'Situation de la pièce',
    RoomEdit_Type: 'Type de la pièce',
    RoomEdit_Floor: 'Etage',
    RoomEdit_FloorComment: 'Commentaire sur l’étage',
    RoomEdit_RevetementAuSol_Sol: "Présence d'un revêtement au sol",
    RoomEdit_RevetementAuSol_Wall: "Présence d'un revêtement au mur",
    RoomEdit_RevetementAuSol_Stairs: "Présence d'un revêtement sur l'escalier",

    RoomEdit_FloorType: 'Revêtement actuel',
    RoomEdit_Heating: "Présence d'un chauffage au sol",
    RoomEdit_HeatingType: 'Type de chauffage au sol',
    RoomEdit_SearchProduit_BtnTitle: 'Chercher dans notre catalogue',
    CatalogDialog_BackButton_Label: 'Revenir sur Clic&Pose',

    RoomEdit_LameFlooringLayout: 'Disposition ?',
    RoomEdit_LameFlooringLayout_LameVertical: 'Eléments entiers',
    RoomEdit_LameFlooringLayout_ClassiqueVertical: 'Optimisation des découpes',

    LaizeView_Description_Reference_Format: 'RÉF: {reference}',
    LaizeView_Description_Unit_Rouleau: 'Mètres linéaires',

    RoomEdit_Amenagements_Title: 'Mes aménagements',
    RoomEdit_Amenagements_Openings: 'Ouverture(s)',
    RoomEdit_Amenagements_RoomItems: 'Aménagement(s)',
    RoomEdit_Amenagements_Contournements: 'Autre aménagement(s)',
    RoomEdit_Amenagements_EmptyMessage: 'Vous n’avez pas encore ajouter des aménagements dans cette pièce ajouter un.',
    RoomEdit_Amenagements_AddAmenagement: 'Ajouter un aménagement',

    OpeningSelect_Title_Sol: 'Ajouter une ouverture ou{br}un aménagement à votre pièce',
    OpeningSelect_Title_Wall: 'Ajouter une ouverture ou{br}un aménagement à votre mur',
    OpeningSelect_Room_Title_Sol: 'Pièce attachée',
    OpeningSelect_Room_Title_Wall: 'Mur attaché',

    OpeningSelect_OpeningList_Title: 'Ouvertures',
    OpeningSelect_RoomElementList_Title_Sol: 'Aménagements',
    OpeningSelect_RoomElementList_Title_Wall: 'Ouvertures',
    OpeningSelect_ContournementList_Title_Sol: 'Autres aménagements',
    OpeningSelect_ContournementList_Title_Wall: 'Aménagements',
    OpeningSelect_ContournementDialog_Stonewall_Count: 'Nombre de mètre(s) linéaire(s) dans cette pièce:',
    OpeningSelect_ContournementDialog_Count: 'Nombre de {label} dans cette pièce:',
    Contournement_Toast_Success: 'Contournements enregistrés !',

    Opening_Info_TypeTitle: 'Le type d’ouverture*',
    Opening_Info_DimensTitle: 'Dimension*',
    Opening_Info_OtherTitle: 'Autre dimension*',
    OpeningEdit_Title: 'Détail d’Ouverture',

    RoomItem_Info_TypeTitle: 'Le type d’aménagement*',
    RoomItem_Info_HeightTitle_Sol: 'Longueur*',
    RoomItem_Info_HeightTitle_Wall: 'Hauteur*',
    RoomItem_Info_DimensPlaceholder: 'Saisissez la dimension ici',
    RoomItem_Info_DimensUnit: 'cm', //!\\ doublon
    RoomItem_Info_Dimensions: 'Dimension*',
    RoomItem_Info_Dimensions_Format: 'H {height} x l {width}',

    RoomItemEdit_Title: 'Détail d’Aménagement',
    RoomItemEdit_PutFlooring: 'Faut-il y poser le revêtement ?',
    RoomItemEdit_PutPlinthes: 'Faut-il poser des plinthes également ?',

    TagType_ToDo: 'à compléter',
    TagType_Done: 'complet',
    TagType_Error: 'erreur',

    Step_Title_StepProduit: 'Mon produit',
    Step_Title_StepPose: 'Ma pose',
    Step_Title_StepSupport: 'Mon support',
    Step_Title_StepPreparation: 'Ma préparation',
    Step_Title_StepFinitions: 'Mes finitions',

    Appointment_Button_Title: 'Je prends rendez-vous',
    Appointment_Button_ShortTitle: 'Prendre RDV',

    HabitationEdit_Title: 'Informations générales',
    HabitationEdit_Subtitle: 'Complétez les informations manquantes sur votre projet.',

    CopyProperties_Copy: 'Recopier',
    CopyProperties_CopyValidate: 'Valider la recopie',
    CopyProperties_Continue: 'Passer',
    CopyProperties_Room_Sol: "Souhaitez-vous recopier les réponses d'une autre pièce ?",
    CopyProperties_Room_Wall: "Souhaitez-vous recopier les réponses d'un autre mur ?",
    CopyProperties_Room_Stairs: "Souhaitez-vous recopier les réponses d'un autre escalier ?",
    CopyProperties_Dialog_Room_Sol: "Recopier les réponses d'une autre pièce",
    CopyProperties_Dialog_Room_Wall: "Recopier les réponses d'un autre mur",
    CopyProperties_Dialog_Room_Stairs: "Recopier les réponses d'un autre escalier",
    CopyProperties_Opening: "Souhaitez-vous recopier les réponses d'une autre ouverture ?",
    CopyProperties_Dialog_Opening: "Recopier les réponses d'une autre ouverture",
    CopyProperties_RoomItem: "Souhaitez-vous recopier les réponses d'un autre aménagement ?",
    CopyProperties_Dialog_RoomItem: "Recopier les réponses d'un autre aménagement",

    RoomDimens_Title: 'Détail de votre pièce',
    RoomDimens_Orientation: 'Orientation de la pièce',
    RoomDimens_Rotate_AntiHoraire: '- 90°',
    RoomDimens_Rotate_Horaire: '+ 90°',
    RoomDimens_Title_Sol: 'Préciser les dimensions principales de votre pièce',
    RoomDimens_Title_Wall: 'Préciser les dimensions principales de votre mur',
    RoomDimens_Shape_Sol: 'La forme de votre pièce*',
    RoomDimens_Shape_Wall: 'La forme de votre mur*',

    Dimens_AreaTitle: 'Surface*',
    Dimens_WidthTitle: 'Largeur*',
    Dimens_HeightTitle: 'Longueur*',
    Dimens_HeightTitle_Sol: 'Longueur*',
    Dimens_HeightTitle_Wall: 'Hauteur*',
    Dimens_InputPlaceholder: 'Saisissez la dimension ici',
    Dimens_DimensUnit: 'cm',
    Dimens_ErrorLimits: 'Veuillez saisir la largeur comprise entre ({min}) et ({max}) cm',
};

export type StringKey = keyof typeof frMessages;
